<template>
  <div class="tender-list-cell tender-list-cell_value tender-list-cell_footer spacex-4">
    <v-skeleton-loader v-if="!value" type="text" width="50" />
    <div v-else class="d-contents spacex-4">
      <div v-if="value && currencySymbol" class="table-cell-currency">{{ currencySymbol }}</div>
      <div>{{ cellValue }}</div>
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import { VSkeletonLoader } from 'vuetify/lib';

  export default {
    name: 'TenderListFooterCell',
    components: {
      VSkeletonLoader,
    },
    props: {
      value: {
        type: String,
        required: true,
      },
      currencySymbol: {
        type: String,
        required: true,
      },
    },
    computed: {
      cellValue() {
        return this.value ? this.addSpaces(this.value) : '';
      },
    },
    methods: {
      addSpaces,
    },
  };
</script>
